import ErrorPage from "components/Blocks/ErrorPage/ErrorPage";

export default ErrorPage;
